import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import RUNewLotModal from './RUNewLotModal';
import { UR_CREATION_GROUP, NEGOTIATION_PHASE, UR_PHASE } from '../../../../Utils/Constants';
import { handleSpecialCharacters } from '../../../../Utils/Helper';


const styles = ({
  titleHead: {
    backgroundColor: '#F6F6F6',
    flex: '0 0 auto',
  },
  titleNoButtons: {
    padding: '18px 0px'
  },
  secondToolBar: {
    paddingLeft: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  secondToolBarNoButton: {
    paddingRight: '12px'
  },
  buttonPlaceHolder: {
    display: 'flex',
    alignItems: 'inherit'
  },
  formControl: {
    minWidth: '150px'
  },
  searchField: {
    width: '240px',
    margin: '16px 8px 0px 0px'
  },
  searchIconMargin: {
    marginRight: '4px'
  }
});

class RULotToolBar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      negotiationLotStateID: this.props.showContent === 'creationUsedRentals' ? NEGOTIATION_PHASE : this.props.showContent === 'usedRentals' ? UR_PHASE : 0,
      searchBy: ''
    }
  }

  handleChangeState = name => event => {
    this.setState({ [name]: event.target.value });
    this.props.reloadTableByState(event.target.value);
  };

  handleSearch = event => {
    this.setState({ searchBy: handleSpecialCharacters(event.target.value) });
    this.props.reloadTableBySearch(handleSpecialCharacters(event.target.value));
  };

  lotStateList() {
    const nLotStateList = this.props.negotiationLotStateList.map(n => {
      return (
        <MenuItem key={n.value} value={n.value}>
          {n.label}
        </MenuItem>
      );
    })
    return nLotStateList;
  }


  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.secondToolBar, this.props.showContent !== 'negotiation' || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0 ? classes.secondToolBarNoButton : '')}>

        <Typography className={this.props.showContent !== 'negotiation' ? classes.titleNoButtons : classes.titleHead} variant='title' id='tableTitle'>
          {this.props.titleTableList}
        </Typography>

        <div className={classes.buttonPlaceHolder}>

          <FormControl className={classes.formControl}>
            <Grid container spacing={8} alignItems='flex-end'>
              <Grid item>
                <TextField
                  id='search'
                  label=''
                  placeholder='Pesquisar'
                  type='search'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start' className={classes.searchIconMargin}>
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  className={classes.searchField}
                  value={this.state.searchBy}
                  onChange={this.handleSearch}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl className={classes.formControl}>
            <InputLabel htmlFor='lot_state'>Estado do Lote</InputLabel>
            <Select
              value={this.state.negotiationLotStateID}
              onChange={this.handleChangeState('negotiationLotStateID')}
              name='negotiationLotStateID'
              displayEmpty
            >
              {this.lotStateList()}
            </Select>
          </FormControl>

          {this.props.showContent !== 'creationUsedRentals' || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0 ?
            null
            :
            <RUNewLotModal reloadTable={this.props.reloadTable} />}

        </div>

      </div>
    );
  }

};

RULotToolBar.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableByState: PropTypes.func.isRequired,
  reloadTableBySearch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RULotToolBar));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsLots/RULotToolBar.js